import MModal from './index.vue';

MModal.install = app => {
  app.component(MModal.name, MModal);
};

export default MModal;
